<style lang="scss" scoped>
.footer {
	@include container;

	overflow: hidden;
	clear: both;
	margin-bottom: 70px;
	font-family: proxima-nova;
	text-align: center;

	@include media-breakpoint-up(md) {
		text-align: left;
	}

	.version-number {
		color: rgb(177, 177, 177);
		display: inline;
		font-size: 12px;
		margin: auto;
		padding-left: 10px;
	}

	&__inside {
		padding-top: 20px;
		border-top: 1px solid #e1e1e1;
	}

	&__item {
		font-weight: 500;
		display: inline-block;

		a {
			color: #627174;

			&:hover {
				color: #4b5658;
			}
		}

		&.\--right {
			margin-top: 20px;

			@include media-breakpoint-up(md) {
				margin-top: 0;
				float: right;
				margin-left: 20px;
			}
		}
	}
}
</style>

<template lang="pug">
footer.footer
    .footer__inside
        .footer__item Copyright © {{ year }} Wonde Ltd. All rights reserved.
        .version-number v{{ version }}
        .footer__item.--right
            a(target="_blank", :href="_privacyNotice.public_url") {{ _privacyNotice.label }}
            | &nbsp;|&nbsp;
            a(target="_blank", :href="_termsOfUse.public_url") {{ _termsOfUse.label }}
</template>

<script>
import moment from "moment";
import shardLinks from "@/components/mixins/shardLinks.mixin";
import { applicationVersion } from "@/utils/common";

export default {
	mixins: [shardLinks],
	computed: {
		version() {
			return applicationVersion;
		},
		year() {
			return moment().year();
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/global/Footer.vue